import { render, staticRenderFns } from "./shetu.vue?vue&type=template&id=0d63a56e&"
import script from "./shetu.vue?vue&type=script&lang=ts&"
export * from "./shetu.vue?vue&type=script&lang=ts&"
import style0 from "./shetu.vue?vue&type=style&index=0&id=0d63a56e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports